import {
  IntIteratordtlvcwxsuu5a as IntIterator,
  CharIterator2h6gbyxoj1es2 as CharIterator,
} from '../collections/PrimitiveIterators.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
  Char__compareTo_impl_ypi4mb1yxpplfe5vmm as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IntProgressionIteratorClass;
function IntProgressionIterator() {
  if (IntProgressionIteratorClass === VOID) {
    class $ extends IntIterator() {
      constructor(first, last, step) {
        super();
        this.hp_1 = step;
        this.ip_1 = last;
        this.jp_1 = this.hp_1 > 0 ? first <= last : first >= last;
        this.kp_1 = this.jp_1 ? first : this.ip_1;
      }
      q1() {
        return this.jp_1;
      }
      pk() {
        var value = this.kp_1;
        if (value === this.ip_1) {
          if (!this.jp_1)
            throw NoSuchElementException().t6();
          this.jp_1 = false;
        } else {
          this.kp_1 = this.kp_1 + this.hp_1 | 0;
        }
        return value;
      }
    }
    initMetadataForClass($, 'IntProgressionIterator');
    IntProgressionIteratorClass = $;
  }
  return IntProgressionIteratorClass;
}
var CharProgressionIteratorClass;
function CharProgressionIterator() {
  if (CharProgressionIteratorClass === VOID) {
    class $ extends CharIterator() {
      constructor(first, last, step) {
        super();
        this.lp_1 = step;
        var tmp = this;
        // Inline function 'kotlin.code' call
        tmp.mp_1 = Char__toInt_impl_vasixd(last);
        this.np_1 = this.lp_1 > 0 ? Char__compareTo_impl_ypi4mb(first, last) <= 0 : Char__compareTo_impl_ypi4mb(first, last) >= 0;
        var tmp_0 = this;
        var tmp_1;
        if (this.np_1) {
          // Inline function 'kotlin.code' call
          tmp_1 = Char__toInt_impl_vasixd(first);
        } else {
          tmp_1 = this.mp_1;
        }
        tmp_0.op_1 = tmp_1;
      }
      q1() {
        return this.np_1;
      }
      rk() {
        var value = this.op_1;
        if (value === this.mp_1) {
          if (!this.np_1)
            throw NoSuchElementException().t6();
          this.np_1 = false;
        } else {
          this.op_1 = this.op_1 + this.lp_1 | 0;
        }
        return numberToChar(value);
      }
    }
    initMetadataForClass($, 'CharProgressionIterator');
    CharProgressionIteratorClass = $;
  }
  return CharProgressionIteratorClass;
}
//region block: exports
export {
  CharProgressionIterator as CharProgressionIterator34nq4ujuknl08,
  IntProgressionIterator as IntProgressionIterator2ovd1ctrmu51n,
};
//endregion

//# sourceMappingURL=ProgressionIterators.mjs.map
